import React from 'react';

function CalendarEditor({ pageContent, setPageContent, addTableRow, deleteTableRow, updateTableRow }) {
  return (
    <div className="page-editor">
      <div className="editor-card">
        <h3>📅 Academic Calendar</h3>
        <div className="form-group">
          <label>Session</label>
          <input value={pageContent.session || '2025-26'} onChange={(e) => setPageContent({...pageContent, session: e.target.value})} style={{maxWidth:200}} className="form-input" />
        </div>
        {(pageContent.calendarEvents || []).map((e) => (
          <div key={e.id} style={{display:'flex',gap:8,marginBottom:8}}>
            <input type="date" value={e.date || ''} onChange={(e) => updateTableRow('calendarEvents', e.id, 'date', e.target.value)} className="form-input" />
            <input placeholder="Event Name" value={e.event || ''} onChange={(e) => updateTableRow('calendarEvents', e.id, 'event', e.target.value)} className="form-input" />
            <button className="remove-btn" onClick={() => deleteTableRow('calendarEvents', e.id)}>🗑️</button>
          </div>
        ))}
        <button className="add-btn" onClick={() => addTableRow('calendarEvents', { date: new Date().toISOString().split('T')[0], event: '' })}>+ Add Event</button>
      </div>
    </div>
  );
}

export default CalendarEditor;